$(function() {
  $('.select2').select2({
    language: "pt-BR",
    width: '100%',
  });
  $('.select2-top').select2({
    language: "pt-BR",
    width: 'calc(100% - 38px)',
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/commons/selects.js